<template>
    <div class="living">
        <h3 class="live-top flex flex-vertical-center">
            <span class="live-top-title">{{ date }}</span>
            <span class="live-top-time">{{ week }}</span>
        </h3>
        <div class="live-container flex">
            <div class="living-content">
                <div class="content">
                    <div class="flex flex-between">
                        <div class="flex flex-column">
                            <p class="subjuect">{{ baseData.name }}</p>
                            <span class="teacher">{{
                                `授课老师：${baseData.teacher_name} / 科目：【${baseData.subject_name}】`
                            }}</span>
                        </div>
                        <div class="flex">
                            <hk-button
                                v-if="doTestStatus"
                                text="做作业"
                                :customStyle="buttonStyle2"
                                @handleClick="toTest(baseData.id)"
                            ></hk-button>
                            <hk-button
                                v-if="baseData.work_status > 0"
                                text="查看解析"
                                :customStyle="buttonStyle"
                                @handleClick="toAnalysis(baseData.id)"
                            ></hk-button>
                            <hk-button
                                v-if="data.length !== 0"
                                class="ml-16"
                                text="立即预约"
                                :customStyle="{ ...buttonStyle, ...disabledStyle }"
                                @handleClick="handleClick"
                            ></hk-button>
                        </div>
                    </div>
                    <div class="subcribe-times">
                        <ul class="flex flex-start flex-vertical-center flex-wrap">
                            <li
                                v-for="(item, index) in data"
                                :key="index"
                                :class="[
                                    {
                                        active: timesActive === index,
                                        manFull:
                                            item.reserve_count === item.max_reserve || item.expired
                                    },
                                    'times-item'
                                ]"
                                @click="chooseTimes(index, item)"
                            >
                                <p class="times">
                                    {{ startTime(item.live_start_time) }}
                                </p>
                                <p class="person-count">
                                    {{
                                        item.reserve_count === item.max_reserve
                                            ? '已满员'
                                            : `${item.reserve_count} / ${item.max_reserve} 人`
                                    }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from '@plugins/_moment';
import HkButton from '@components/HkButton';
import { subcribeLive } from '@api/liveList';
export default {
    name: 'UnSubscribe',
    components: {
        HkButton
    },
    props: {
        data: {
            require: true,
            type: [Object, Array]
        },
        baseData: {
            require: true,
            type: Object
        }
    },
    data() {
        return {
            buttonStyle: {
                width: '110px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            buttonStyle2: {
                width: '110px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            timesActive: ''
        };
    },

    computed: {
        date() {
            const time = this.baseData.show_time;
            const now = moment().locale('zh-cn').format('YYYY-MM-DD HH:mm:ss');
            const weekTime = moment(time).format('YYYY-MM-DD HH:mm:ss');
            if (now === weekTime) {
                return '今日课程';
            }
            return moment(time).format('MM月DD日');
        },
        week() {
            const showTime = this.baseData.show_time;
            const momentTime = moment(showTime);
            return momentTime.format('dddd');
        },
        endTime() {
            const time = this.data.live_end_time;
            return moment(time).format('HH:mm');
        },
        disabled() {
            return (
                this.data.reduce((prev, current) => prev && current.expired, true) ||
                this.data.some((item) => item.am_i_reserved && item.expired)
            );
        },
        disabledStyle() {
            const disabled = this.disabled;
            return disabled
                ? {
                      shadowColor: 'transparent',
                      startColor: '#D7D7D7',
                      endColor: '#D7D7D7'
                  }
                : {};
        },

        doTestStatus() {
            const { baseData, data } = this;
            return (
                baseData.work_id > 0 &&
                !baseData.work_status &&
                data.some((item) => item.am_i_reserved && item.live_end_time)
            );
        }
    },

    created() {},

    methods: {
        startTime(time) {
            const interimTime = time;
            return moment(interimTime).format('M月D H:mm');
        },
        chooseTimes(index, item) {
            if (item.expired) {
                return;
            }
            this.timesActive = index;
        },
        handleClick() {
            const { data, timesActive, disabled } = this;
            if (disabled) {
                return;
            }
            if (!data[timesActive]) {
                this.$message.error('请先选择场次进行预约');
                return;
            }
            if (data[timesActive].reserve_count >= data[timesActive].max_reserve) {
                return;
            }
            subcribeLive({
                schedule_id: data[timesActive].schedule_id,
                live_id: data[timesActive].id
            }).then((res) => {
                if (res.code === 0) {
                    this.$message({
                        message: '预约成功',
                        type: 'success'
                    });
                    this.$store.dispatch('queryLiveList');
                    this.$store.dispatch('queryUserInfo');
                }
            });
            this.$trackEvent('直播', '预约', data[timesActive].id);
        },
        toTest(id) {
            this.$trackEvent('答题', '开始做题', id);
            this.$router.push({ name: 'Test', query: { scheduleId: id } });
        },
        toAnalysis(id) {
            this.$trackEvent('答题', '解析', id);
            this.$router.push({ name: 'Analysis', query: { scheduleId: id } });
        }
    }
};
</script>
<style lang="scss" scoped>
.living {
    width: 100%;
    .live-top {
        margin-bottom: 13px;
        span {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333;
        }
        .live-top-title {
            margin-right: 30px;
        }
    }
    .live-container {
        align-items: flex-start;
        .living-time {
            margin-right: 52px;
            margin-top: 2px;
            width: 78px;
            .start-time {
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 800;
                color: #333;
                margin-bottom: 8px;
            }
            .end-time {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666;
            }
        }
        .living-content {
            width: calc(100% - 126px);
            margin-left: 126px;
            padding-left: 12px;
            border-left: 1px solid #e5e5e5;
            .content {
                box-sizing: border-box;
                width: 100%;
                border-radius: 20px;
                background-color: #f9f9f9;
                padding: 20px 20px 20px 36px;
                .subjuect {
                    font-size: 16px;
                    font-weight: 800;
                    color: #333;
                    margin-bottom: 14px;
                }
                .teacher {
                    font-size: 14px;
                    font-weight: 500;
                    color: #666;
                }
                .subscribe-count {
                    font-size: 14px;
                    font-weight: 500;
                    color: #666;
                    margin-bottom: 14px;
                }
            }
            .times-item {
                box-sizing: border-box;
                width: 128px;
                height: 56px;
                background: #f3f5fa;
                border: 1px solid #cacbcd;
                border-radius: 4px;
                padding: 10px 15px;
                cursor: pointer;
                position: relative;
                margin-top: 13px;
                .times {
                    font-size: 14px;
                    font-weight: 500;
                    color: #333;
                    margin-bottom: 4px;
                }
                .person-count {
                    font-size: 12px;
                    font-weight: 400;
                    color: #333;
                }
            }
            .active {
                background: #f7f1ff;
                border: 1px solid #6d33b3;
                cursor: default;
                .times {
                    color: #6d33b3;
                }
                .person-count {
                    color: #6d33b3;
                }
            }
            .manFull {
                cursor: not-allowed;
                .times {
                    color: #999;
                }
                .person-count {
                    color: #999;
                }
            }
            .times-item:not(:last-child) {
                margin-right: 10px;
            }
        }
    }
}
</style>
